<div class="reassign-staff">
  <div class="content">
    <!-- Selection View -->
    <div *ngIf="!selectedReassignmentType" class="selection-view">
      <h2 class="page-title">Select Reassignment Type</h2>

      <div class="reassignment-options">
        <div
          class="reassignment-option"
          *ngFor="let option of reassignmentOptions; let i = index"
          (click)="selectReassignmentType(option)"
        >
          <div class="option-icon">
            <mat-icon>{{ option.icon }}</mat-icon>
          </div>
          <div class="option-content">
            <h3 class="option-title">{{ option.title }}</h3>
            <p class="option-description">{{ option.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Building Reassignment View -->
    <app-building-reassignment
      *ngIf="showBuildingReassignment"
      (goBack)="goBack()"
    ></app-building-reassignment>

    <!-- Primary Manager Reassignment View -->
    <app-primary-manager-reassignment
      *ngIf="showPrimaryManagerReassignment"
      (goBack)="goBack()"
    ></app-primary-manager-reassignment>

    <!-- Secondary Manager Reassignment View -->
    <app-secondary-manager-reassignment
      *ngIf="showSecondaryManagerReassignment"
      (goBack)="goBack()"
    ></app-secondary-manager-reassignment>

    <!-- Requirement Reassignment View -->
    <app-requirement-reassignment
      *ngIf="showRequirementReassignment"
      (goBack)="goBack()"
    ></app-requirement-reassignment>

    <!-- User Roles Reassignment View -->
    <app-user-roles-reassignment
      *ngIf="showUserRolesReassignment"
      (goBack)="goBack()"
    ></app-user-roles-reassignment>

    <!-- Coming Soon View -->
    <div
      *ngIf="
        selectedReassignmentType &&
        !showBuildingReassignment &&
        !showPrimaryManagerReassignment &&
        !showSecondaryManagerReassignment &&
        !showRequirementReassignment &&
        !showUserRolesReassignment
      "
      class="coming-soon-view"
    >
      <div class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Reassignment Types</span>
      </div>

      <div class="coming-soon-content">
        <div class="coming-soon-icon">
          <mat-icon>{{ selectedReassignmentType.icon }}</mat-icon>
        </div>
        <h2 class="coming-soon-title">
          {{ selectedReassignmentType.title }} is coming soon
        </h2>
        <p class="coming-soon-description">
          We're working hard to bring you the
          {{ selectedReassignmentType.title.toLowerCase() }} functionality. This
          feature will be available in a future update.
        </p>
        <div class="coming-soon-actions">
          <button class="back-to-selection-btn" (click)="goBack()">
            Back to Selection
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
